import { render, staticRenderFns } from "./item-badges.vue?vue&type=template&id=28dd263e&scoped=true"
import script from "./item-badges.vue?vue&type=script&lang=js"
export * from "./item-badges.vue?vue&type=script&lang=js"
import style0 from "./item-badges.vue?vue&type=style&index=0&id=28dd263e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd263e",
  null
  
)

export default component.exports